import { render } from "./TrainingSectionIconBlockItem.vue?vue&type=template&id=d52f595e&scoped=true"
import script from "./TrainingSectionIconBlockItem.vue?vue&type=script&lang=js"
export * from "./TrainingSectionIconBlockItem.vue?vue&type=script&lang=js"

import "./TrainingSectionIconBlockItem.vue?vue&type=style&index=0&id=d52f595e&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d52f595e"]])

export default __exports__